import { Dialog } from "primereact/dialog"
import { PPDefaultSelector } from "../../components/ui/PPDefaultSelector";
import { useState, useEffect } from "react";

function toSelectorOptions(options) {
     const headers = options.map((x) => x.header ?? x.label ?? "")
     const headerCount = headers.reduce((acc, h) => {
          acc[h] = (acc[h] || 0) + 1
          return acc
     }, {})
     return options.map((x) => {
          const h = x.header ?? x.label ?? ""
          const v = x.field ?? x.value
          const label = headerCount[h] > 1 && v != null ? `${h} (${v})` : h
          return { label, value: v }
     })
}

export default function PPColumnSelectModal({
     instanceId,
     header,
     visible,
     onHide,
     options, 
     setOption, 
}){
     const allOptions = toSelectorOptions(options)
     const activeOptions = options
          .filter(x => x.active)
          .map((x) => toSelectorOptions([x])[0])
     
     const [tmpSelect, setTempSelect] = useState(activeOptions);
  
     useEffect(() => {
          if (visible) {
               const activeOpts = options
                    .filter(x => x.active)
                    .map((x) => toSelectorOptions([x])[0])
               setTempSelect(activeOpts);
          }
     }, [visible, options]);

     const handleSelectAll = () => {
          setTempSelect(allOptions);
     };

     const handleDeselectAll = () => {
          setTempSelect([]);
     };

     return (
          <Dialog
               key={`dialog_${instanceId}`} 
               header={header}
               footer={
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                         <div style={{ display: 'flex', gap: '10px' }}>
                              <button className="btn btn-sm btn-outline-secondary" onClick={handleSelectAll} type="button">
                                   <i className="fas fa-check"></i> Alle auswählen
                              </button>
                              <button className="btn btn-sm btn-outline-secondary" onClick={handleDeselectAll} type="button">
                                   <i className="fas fa-times"></i> Alle abwählen
                              </button>
                         </div>
                         <button className="btn btn-primary" onClick={() => {
                              setOption(tmpSelect)
                              onHide()
                         }} type="button">OK</button>
                    </div>
               }
               visible={visible} 
               style={{ width: '60vw', maxHeight: '80vh' }} 
               contentStyle={{ overflow: 'visible' }}
               onHide={onHide}
               modal={true}
               dismissableMask={true}
          >
               <div style={{ marginBottom: '15px' }}>
                    <p className="text-muted">
                         <i className="fas fa-info-circle"></i> {tmpSelect.length} von {allOptions.length} Spalten ausgewählt
                    </p>
               </div>
               <PPDefaultSelector
                    id={instanceId}
                    isMulti={true}
                    onChange={setTempSelect}
                    data={allOptions}
                    value={tmpSelect}
                    menuInPortal
                    customStyles={{
                         menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                         menu: (base) => ({ ...base, zIndex: 9999 })
                    }}
               />
          </Dialog>
     );
}